// extracted by mini-css-extract-plugin
export var bodySections = "_43-8";
export var gray = "_43-7";
export var green = "_43-4";
export var iconContainer = "_43-9";
export var iconWidgetContainer = "_43-1";
export var phoneIcon = "_43-2";
export var red = "_43-5";
export var statusDot = "_43-3";
export var widgetContainer = "_43-0";
export var yellow = "_43-6";